"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

/**
 * Swaps body class between `tactic-v2` (web app) and `tactic-kiosk` (kiosk routes).
 * Prevents web app CSS scoped under `.tactic-v2` from affecting kiosk pages and vice versa.
 */
export const BodyClassManager: React.FC = () => {
  const pathname = usePathname();

  useEffect(() => {
    const isKiosk = pathname?.startsWith("/kiosk");

    if (isKiosk) {
      document.body.classList.remove("tactic-v2");
      document.body.classList.add("tactic-kiosk");
    } else {
      document.body.classList.remove("tactic-kiosk");
      document.body.classList.add("tactic-v2");
    }
  }, [pathname]);

  return null;
};
